import React from 'react';
import { track } from '../lib/analytics';

const Hero = ({ onCTAClick }) => {
  const handleCTA = () => {
    track('hero_cta_click', { value: 'register_your_interest' });
    onCTAClick?.();
  };
  return (
    <div id="top" style={{ position: 'relative' }}>
      <section
        data-testid="hero-section"
        className="yup-fade-up"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '120px 24px 80px',
          maxWidth: '900px',
          margin: '0 auto',
        }}
      >
        <p
          data-testid="hero-eyebrow"
          style={{
            fontSize: '11px',
            letterSpacing: '3px',
            textTransform: 'uppercase',
            color: 'var(--yup-warm)',
            marginBottom: '28px',
            fontWeight: 400,
          }}
        >
          30 Days · Unmask Your Voice
        </p>

        <h1
          data-testid="hero-headline"
          className="font-serif"
          style={{
            fontSize: 'clamp(42px, 8vw, 88px)',
            fontWeight: 300,
            lineHeight: 1.05,
            letterSpacing: '-1px',
            color: 'var(--yup-ink)',
            marginBottom: '32px',
          }}
        >
          There's a voice<br />
          trapped inside<br />
          <em style={{ fontStyle: 'italic', color: 'var(--yup-accent)' }}>your head.</em>
        </h1>

        <div
          aria-hidden="true"
          style={{
            width: '60px',
            height: '1px',
            background: 'var(--yup-warm)',
            marginBottom: '32px',
          }}
        />

        <p
          data-testid="hero-subtext"
          style={{
            fontSize: 'clamp(16px, 2.5vw, 20px)',
            color: 'var(--yup-muted)',
            maxWidth: '560px',
            lineHeight: 1.7,
            marginBottom: '48px',
            fontWeight: 300,
          }}
        >
          Trapped by masks, systems and habits you built when you needed them.
          <br />
          <strong style={{ color: 'var(--yup-ink)', fontWeight: 500 }}>
            Sharing it out loud — even just once — starts to set it free.
          </strong>
        </p>

        <div className="flex flex-wrap items-center" style={{ gap: '16px' }}>
          <button
            type="button"
            onClick={handleCTA}
            data-testid="hero-cta-register"
            className="btn-yup-primary"
          >
            Register Your Interest
          </button>
          <a
            href="#what"
            data-testid="hero-cta-what"
            className="btn-yup-ghost"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('what')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            What is this?
          </a>
        </div>
      </section>

      <div
        className="yup-fade-in"
        data-testid="scroll-hint"
        style={{
          position: 'absolute',
          bottom: '40px',
          left: '24px',
          fontSize: '11px',
          letterSpacing: '2px',
          textTransform: 'uppercase',
          color: 'var(--yup-muted)',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <span
          aria-hidden="true"
          style={{ width: '30px', height: '1px', background: 'var(--yup-muted)' }}
        />
        Scroll to find out more
      </div>
    </div>
  );
};

export default Hero;
